export default {
  getCurrencies: state => state.currencies,
  getCurrencyRates: state => state.currencyRates,
  getCurrencyRatesAllStore: state => state.currencyRatesAllStore
}
